import { render, staticRenderFns } from "./ProductTags.vue?vue&type=template&id=4d0ed2e6&scoped=true"
import script from "./ProductTags.vue?vue&type=script&lang=js"
export * from "./ProductTags.vue?vue&type=script&lang=js"
import style0 from "./ProductTags.vue?vue&type=style&index=0&id=4d0ed2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ed2e6",
  null
  
)

export default component.exports